var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-button',{staticClass:"button",class:`style${_vm.type}`,attrs:{"round":"","native-type":_vm.nativeType,"icon":_vm.icon,"disabled":_vm.disabled},on:{"click":_vm.buttonCustomClick}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }